/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { CustomModal, CustomTitle } from 'src/components'
import { RequestForProposalPayload } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import ProposalFormContent from './ProposalFormContent/ProposalFormContent'
import RequestProposalResults from './RequestProposalResults/RequestProposalResults'
import {
  sendRequestForProposalSelector,
  resetRequestForProposalState,
  sendRequestForProposal,
} from 'src/features'

interface RequestForProposalModalProps {
  isModalVisible: boolean,
  handleCancel: () => void
}

const RequestForProposalModal: React.FC<RequestForProposalModalProps> = (props) => {
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [isResultsVisible, setIsResultsVisible] = useState(false)
  const { success: successRequest } = useAppSelector(sendRequestForProposalSelector)

  useEffect(() => {
    if (successRequest) {
      dispatch(resetRequestForProposalState())
      form.resetFields()
      setIsResultsVisible(true)
    }
  }, [successRequest])

  const handleCancel = () => {
    setIsResultsVisible(false)
    form.resetFields()
    props.handleCancel()
  }

  const formProps = {
    onFinish: (values: RequestForProposalPayload) => {
      dispatch(sendRequestForProposal(values))
    }, form
  }

  return (
    <CustomModal
      title={!isResultsVisible && <CustomTitle label={t('RequestProposal.ModalTitle')} type={null} />}
      footer={null}
      visible={props.isModalVisible}
      onCancel={handleCancel}
      width={650}
    >
      {!isResultsVisible ? <Form {...formProps}><ProposalFormContent form={form} />
      </Form>: <RequestProposalResults setIsResultsVisible={setIsResultsVisible} />}
    </CustomModal>
  )
}

export default RequestForProposalModal
